export default {"src":"/_next/static/media/beautiful-space.7ba358d5.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};